module.exports = __webpack_public_path__ + "img/hall-card-disabled-tall.f5dd3869.png";